import { pick } from 'ramda';
import { useEffect } from 'react';
import { useCookieSettingsSelector } from 'js/store/hooks';

/**
 * Event fires when Cookies Settings component values is changed.
 * @memberOf Playtech.API.events
 * @event cookie-settings-updated
 * @property name {String} Name of the cookie type.
 * @property value {String} Value.
 * @example Playtech.on('cookie-settings-updated', ({ name, value }) => {
 *     // ...
 * });
 */
export const EVENT_COOKIE_SETTINGS_UPDATED = 'cookie-settings-updated';

export const useOnCookieSettingsUpdated = (eventTarget) => {
    const { groupsData, isInitialSetup } = useCookieSettingsSelector(pick(['groupsData', 'isInitialSetup']));

    useEffect(() => {
        if (isInitialSetup) {
            return;
        }

        Object.keys(groupsData).forEach((key) => {
            const event = new CustomEvent(
                EVENT_COOKIE_SETTINGS_UPDATED,
                {
                    detail: {
                        name: key,
                        value: groupsData[key]
                    }
                }
            );

            eventTarget.dispatchEvent(event);
        });
    }, [groupsData, eventTarget, isInitialSetup]);
};
